import React from "react";
import PropTypes from "prop-types";
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from "@mui/material";
import * as TextVariables from "../../../assets/Variables/TextVariables";
import Colors from "../../../assets/Variables/ColorsVariables";
import { Spaces } from "../../../assets/Variables/SpaceVariables";

const SelectorSimple = ({ label, value, onChange, options, error, helperText, name, sx }) => {
  const defaultStyles = {
    fontFamily: TextVariables.Overline,
    borderRadius: Spaces.Size_2,
    width: "180px",
    minWidth: "160px",
    height: "44px",
    padding: "0px",
    lineHeight: 1,
    "& .MuiOutlinedInput-root": {
      borderRadius: Spaces.Size_2,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: error ? Colors.Error_700 : Colors.Secondary_400,
    },
    "& .MuiSelect-select": {
      padding: `${Spaces.Size_3} 12px`,
      lineHeight: "22px",
      minHeight: "22px",
      display: "flex",
      alignItems: "center",
    },
  };

  return (
    <FormControl variant="outlined" sx={{ ...defaultStyles, ...sx }} error={error} size="medium" fullWidth={false}>
      <InputLabel>{label}</InputLabel>
      <Select
        label={label}
        value={value}
        onChange={onChange}
        name={name}
        displayEmpty
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

SelectorSimple.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  name: PropTypes.string,
  sx: PropTypes.object,
};

SelectorSimple.defaultProps = {
  error: false,
  helperText: "",
  name: "",
  sx: {},
};

export default SelectorSimple;
